import { createIcon } from '@chakra-ui/react';

export const DisputeOutlineIcon = createIcon({
  displayName: 'DisputeOutlineIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M12.3136 11.7199L12.5736 13.8266C12.6402 14.3799 12.0469 14.7666 11.5736 14.4799L8.78022 12.8199C8.47356 12.8199 8.17356 12.7999 7.88023 12.7599C8.37356 12.1799 8.66689 11.4466 8.66689 10.6532C8.66689 8.75991 7.02689 7.2266 5.00022 7.2266C4.22689 7.2266 3.51356 7.44659 2.92023 7.83325C2.90023 7.66659 2.89355 7.49991 2.89355 7.32658C2.89355 4.29325 5.52689 1.83325 8.78022 1.83325C12.0336 1.83325 14.6669 4.29325 14.6669 7.32658C14.6669 9.12658 13.7402 10.7199 12.3136 11.7199Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.66634 10.6532C8.66634 11.4465 8.37301 12.1799 7.87968 12.7599C7.21968 13.5599 6.17301 14.0732 4.99967 14.0732L3.25967 15.1065C2.96634 15.2865 2.59301 15.0399 2.63301 14.6999L2.79967 13.3866C1.90634 12.7666 1.33301 11.7732 1.33301 10.6532C1.33301 9.47986 1.95968 8.44654 2.91968 7.83321C3.51301 7.44654 4.22634 7.22656 4.99967 7.22656C7.02634 7.22656 8.66634 8.75987 8.66634 10.6532Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
